// Import necessary React and MUI modules
import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import robot from "../../../assest/image/robot.png";
import "./login.css";
import { InputAdornment, TextField } from "@mui/material";
import Loginbutton from "../../../components/common/loginButton/loginbutton";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useFormik } from "formik";
import * as Yup from "yup";
import { handleLoginAPi } from "../../../redux/action/AuthAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Cookies from "js-cookie";
import { GroupSelect } from "../../../components/common/dropDown/groupSelect";
import BusinessIcon from "@mui/icons-material/Business";
import { authSelector } from "../../../redux/slices/authSlice";

// Style for the modal container
const style = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  maxHeight: 520,
  maxWidth: 500,
  height: "100%",
  backdropFilter: "blur(8px)",
  border: "none",
  outline: "none",
};

// Main modal component
export default function BasicModal({ open, setOpen, Addacc }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Retrieve user data from cookies
  const userdata = Cookies.get("userAccounts");
  const userDetails = userdata ? JSON.parse(userdata) : [];

  // Get organization data from Redux store
  const { organizationsData } = useSelector(authSelector);

  // Local state management
  const [multiOrg, setMultiOrg] = React.useState(false);
  const [selectedDateLabel, setSelectedDateLabel] = React.useState("");
  const [passwordShow, setPasswordShow] = React.useState(true);

  // Formik setup with validation
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      const data = {
        username: values?.username,
        password: values?.password,
        organization: selectedDateLabel,
      };

      // Call API depending on if user has multiple orgs
      multiOrg
        ? dispatch(handleLoginAPi(navigate, data, setOpen, setMultiOrg))
        : dispatch(handleLoginAPi(navigate, values, setOpen, setMultiOrg));
    },
  });

  // Toggle password visibility
  const handlePassword = () => {
    setPasswordShow(!passwordShow);
  };

  // Handle organization dropdown change
  const handleChange = (event) => {
    const selectedId = event.target.value;
    const selectedOption = organizationsData.find(
      (opt) => opt.id === selectedId
    );
    setSelectedDateLabel(selectedOption?.name);
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      disableEscapeKeyDown={true}
      BackdropProps={{ onClick: (e) => e.stopPropagation() }}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: " rgb(255 255 255 / 10%)",
          backdropFilter: "blur(5px)",
        },
      }}
    >
      <Box sx={style}>
        {/* Close button if Addacc is true */}
        {Addacc && (
          <div style={{ right: "5%", top: "5%", position: "absolute" }}>
            <CloseOutlinedIcon onClick={() => setOpen(false)} />
          </div>
        )}

        {/* Logo and robot image */}
        <div className="robot-wrapper">
          <p className="qlogo">qtools.ai</p>
          <img style={{ width: "150px" }} src={robot} alt="robot" />
        </div>

        {/* Login form */}
        <form onSubmit={formik.handleSubmit}>
          <div className="login-input-wrapper">
            {/* Header text */}
            <div className="login-txt-wrapper">
              <AutoAwesomeIcon />
              <p style={{ fontWeight: "600", fontSize: "18px", fontFamily: "poppins" }}>
                Login
              </p>
              <p style={{ color: "#8A8A8A", fontSize: "12px" }}>
                To Explore The Power Of AI
              </p>
            </div>

            {/* Username and organization selection or password */}
            <div className={multiOrg ? "org-input-wrapper" : "login-input-wrapper"}>
              {multiOrg ? (
                <>
                  <p style={{ color: "#8A8A8A", fontSize: "15px" }}>
                    Your email is associated with one or more organizations.
                    Please choose the organization you'd like to continue with.
                  </p>
                  <GroupSelect
                    labelText={"Organization"}
                    labelIcon={<BusinessIcon />}
                    formLabel={"Organization"}
                    options={organizationsData}
                    val={selectedDateLabel}
                    handlechange={handleChange}
                  />
                </>
              ) : (
                <>
                  {/* Username field */}
                  {formik.errors.username && formik.touched.username ? (
                    <p className="error-txt">Username is required</p>
                  ) : (
                    <label style={{ fontSize: "12px", fontWeight: "600" }}>
                      Username / Email
                    </label>
                  )}
                  <TextField
                    fullWidth
                    placeholder="Enter Your Username / Email"
                    id="username"
                    onChange={formik.handleChange}
                    value={formik.values.username}
                    className={
                      formik.errors.username && formik.touched.username
                        ? "input-group-red"
                        : ""
                    }
                    sx={{
                      marginRight: "1rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.6rem",
                        borderRadius: "0.3rem",
                        "& fieldset": {
                          borderWidth: "0.1rem",
                        },
                        "&:hover fieldset": {
                          borderColor: "rgba(203, 203, 203, 1)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3941AB !important",
                          borderWidth: "0.1rem",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "0.8rem",
                        height: "100%",
                        "&:-webkit-autofill": {
                          WebkitBoxShadow: "0 0 0 1000px white inset !important",
                          height: "25%",
                        },
                      },
                    }}
                  />
                </>
              )}

              {!multiOrg && (
                <>
                  {/* Password field */}
                  {formik.errors.password && formik.touched.password ? (
                    <p className="error-txt">Password is required</p>
                  ) : (
                    <label style={{ fontSize: "12px", fontWeight: "600" }}>
                      Password
                    </label>
                  )}
                  <TextField
                    fullWidth
                    id="password"
                    placeholder="Enter Your Password"
                    onChange={formik.handleChange}
                    value={formik.values.password}
                    type={passwordShow ? "password" : "text"}
                    className={
                      formik.errors.password && formik.touched.password
                        ? "input-group-red"
                        : ""
                    }
                    sx={{
                      marginRight: "1rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.6rem",
                        borderRadius: "0.3rem",
                        "& fieldset": {
                          borderWidth: "0.1rem",
                        },
                        "&:hover fieldset": {
                          borderColor: "rgba(203, 203, 203, 1)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3941AB !important",
                          borderWidth: "0.1rem",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "0.8rem",
                        height: "100%",
                        "&:-webkit-autofill": {
                          WebkitBoxShadow: "0 0 0 1000px white inset !important",
                          height: "25%",
                        },
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <div
                            onClick={handlePassword}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              backgroundColor: "white",
                            }}
                          >
                            {passwordShow ? (
                              <VisibilityOutlinedIcon fontSize="small" />
                            ) : (
                              <VisibilityOffOutlinedIcon fontSize="small" />
                            )}
                          </div>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* Forgot password link */}
                  <div className="forgot-password">
                    <a href="/forgotPassword" className="fr-btn">
                      Forgot Password?
                    </a>
                  </div>
                </>
              )}

              {/* Login or Continue button */}
              {Loginbutton({
                text: multiOrg ? "continue" : "Login",
                type: "submit",
              })}
            </div>
          </div>
        </form>
      </Box>
    </Modal>
  );
}



